<template lang="pug">
.bloco-alerta-monitoramento-socioambiental
    .alerta-bloco
        .alerta-bloco--icone
            i.mdi.mdi-alert-outline.mdi-36px

        .alerta-bloco--conteudo
            .bloco-links
                ul
                    li
                        a(
                            @click='atualizarInfoAlertas("DIA")',
                            :class='tempoAlertas === "DIA" ? "ativo" : ""'
                        ) {{ $t('mensagens.blocoAlerta.filtros.hoje') }}
                    li
                        a(
                            @click='atualizarInfoAlertas("SEMANA")',
                            :class='tempoAlertas === "SEMANA" ? "ativo" : ""'
                        ) {{ $t('mensagens.blocoAlerta.filtros.seteDias') }}
                    li
                        a(
                            @click='atualizarInfoAlertas("MES")',
                            :class='tempoAlertas === "MES" ? "ativo" : ""'
                        ) {{ $t('mensagens.blocoAlerta.filtros.trintaDias') }}
                    li
                        a(
                            @click='atualizarInfoAlertas("TODO")',
                            :class='tempoAlertas === "TODO" ? "ativo" : ""'
                        ) {{ $t('mensagens.blocoAlerta.filtros.todoPeriodo') }}

            .bloco-dados
                .bloco-interno
                    span {{ quantidadeAlertas }}
                    .bloco-interno--texto {{ this.$tc('mensagens.blocoAlerta.quantidadeAlertasEncontrados', quantidadeAlertas, { quantidadeAlertas: quantidadeAlertas }) }}
                    a.bloco-interno--detalhes(
                            @click='abrirModalAlertaDetalhes()'
                        ) {{ $t('mensagens.comuns.verDetalhes') }}
    ModalVisualizarDetalhesAlertaSocioambiental(
        :show='mostrarModalDetalhesAlerta',
        :periodo='periodoModalDetalhes',
        @voltar='mostrarModalDetalhesAlerta = false'
    )
</template>

<script>
import AlertaService from '@/services/AlertaService.js';
import ModalVisualizarDetalhesAlertaSocioambiental from './ModalVisualizarDetalhesAlertaSocioambiental.vue';

export default {
    name: 'BlocoAlertaMonitoramentoSocioambiental',

    props: {
        periodoAlerta: {
            type: String,
            default: null
        }
    },

    watch: {
        periodoAlerta: {
            handler() {
                if (this.periodoAlerta) {
                    switch (this.periodoAlerta) {
                        case 'diario':
                            this.atualizarInfoAlertas('DIA');
                            break;
                        case 'semanal':
                            this.atualizarInfoAlertas('SEMANA');
                            break;
                        case 'mensal':
                            this.atualizarInfoAlertas('MES');
                            break;
                        default:
                            break;
                    }
                }
            },
            immediate: true
        }
    },

    components: {
        ModalVisualizarDetalhesAlertaSocioambiental
    },

    data() {
        return {
            tempoAlertas: 'DIA',
            totalAlertas: null,
            mostrarModalDetalhesAlerta: false,
            periodoModalDetalhes: 'hoje'
        };
    },

    computed: {
        quantidadeAlertas() {
            if (!this.totalAlertas) {
                return '-';
            }

            if (this.tempoAlertas === 'DIA') {
                return this.totalAlertas.totalDiario;
            }

            if (this.tempoAlertas === 'SEMANA') {
                return this.totalAlertas.totalSemanal;
            }
            if (this.tempoAlertas === 'TODO') {
                return this.totalAlertas.total;
            }

            return this.totalAlertas.totalMensal;
        }
    },

    async mounted() {
        this.getResumoAlertas();
    },

    methods: {
        getResumoAlertas() {
            AlertaService.getResumoAlertas()
                .then(({ data }) => {
                    this.totalAlertas = data;
                })
                .catch(erro => {
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar o resumo dos alertas' +
                            erro
                    });
                });
        },
        atualizarInfoAlertas(tempo) {
            this.tempoAlertas = tempo;

            if (this.tempoAlertas === 'DIA') {
                this.periodoModalDetalhes = 'hoje';
            }

            if (this.tempoAlertas === 'SEMANA') {
                this.periodoModalDetalhes = 'seteDias';
            }

            if (this.tempoAlertas === 'MES') {
                this.periodoModalDetalhes = 'trintaDias';
            }

            if (this.tempoAlertas === 'TODO') {
                this.periodoModalDetalhes = 'todoPeriodo';
            }
        },
        abrirModalAlertaDetalhes() {
            this.mostrarModalDetalhesAlerta = true;
        }
    }
};
</script>
<style lang="scss">
.bloco-alerta-monitoramento-socioambiental {
    .el-dialog {
        border-radius: 5px;
    }
}

#modal-visualizar-detalhes-alerta-socioambiental
    > div
    > div.el-dialog
    > div.el-dialog__header
    > div.dialog-header {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
</style>

<style lang="scss" scoped>
.alerta-bloco {
    background: #ef99181a;
    display: flex;
    justify-content: flex-start;
    border-radius: 8px;
    align-items: center;

    .alerta-bloco--conteudo {
        padding: 5px 8px;

        .bloco-links {
            height: 100%;
            display: flex;
            align-items: center;

            ul {
                margin: 0;
                padding: 0;
                display: flex;

                li {
                    list-style: none;
                    margin-right: 25px;
                    padding: 7px;
                    color: var(--primary);

                    a:not(.ativo) {
                        cursor: pointer;
                        text-decoration: none;
                    }
                    a:hover {
                        cursor: pointer;
                    }
                    a.ativo:hover {
                        text-decoration: underline;
                        text-decoration-color: var(--warning);
                        text-underline-offset: 5px;
                        text-decoration-thickness: 2px;
                    }
                }
            }
        }
        .bloco-dados {
            margin: 0 8px;

            .bloco-interno {
                display: flex;
                align-items: baseline;
                height: 100%;
                font-weight: 600;
                padding-top: 5px;
                flex-wrap: wrap;

                span {
                    font-size: 22px;
                    color: #3b3b3b;
                    margin-right: 10px;
                }

                a {
                    margin-left: 10px;
                    cursor: pointer;
                    color: rgba(9, 111, 231, 1);
                    font-weight: 400;
                    font-family: Roboto;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
    .alerta-bloco--icone {
        background: var(--warning);
        width: 77px;
        height: 77px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        color: var(--white);
    }

    .ativo {
        font-weight: bold;
        text-decoration: underline;
        text-decoration-color: var(--warning);
        text-underline-offset: 5px;
        text-decoration-thickness: 2px;
    }
}
</style>
